import React, { useState } from 'react';

const BIBTEX = `@inproceedings{li2025saess,
  title     = {Safety Alignment Can Be Not Superficial With Explicit Safety Signals},
  author    = {Jianwei Li and Jung-Eun Kim},
  booktitle = {International Conference on Machine Learning (ICML)},
  year      = {2025},
  url       = {https://arxiv.org/abs/2505.17072}
}`;

export default function CitationSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(BIBTEX);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      // noop
    }
  };

  return (
    <section className="py-20 bg-white border-t border-ink-100">
      <div className="max-w-4xl mx-auto px-6">
        <p className="section-eyebrow mb-3">05 &middot; Cite Us</p>
        <h2 className="section-title">BibTeX</h2>

        <p className="mt-6 text-center text-ink-500 max-w-2xl mx-auto">
          If you find our work helpful, please consider citing us.
        </p>

        <div className="mt-8 relative">
          <button
            onClick={handleCopy}
            className="absolute top-3 right-3 inline-flex items-center gap-1.5 rounded-lg bg-ink-800 px-3 py-1.5 text-xs font-semibold text-white shadow-soft hover:bg-ink-700 transition"
          >
            {copied ? (
              <>
                <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                Copied
              </>
            ) : (
              <>
                <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="9" y="9" width="11" height="11" rx="2" />
                  <path d="M5 15V5a2 2 0 012-2h10" />
                </svg>
                Copy
              </>
            )}
          </button>
          <pre className="overflow-x-auto rounded-2xl bg-ink-900 text-ink-50 text-sm font-mono p-5 md:p-6 leading-relaxed shadow-card">
            <code>{BIBTEX}</code>
          </pre>
        </div>
      </div>
    </section>
  );
}
